import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../../../../lib/actionTypes.es6'
import * as actions from './actions';

import { getComplexCustomerPremiums, removeComplexPremium } from '../../../../../../lib/requests.es6';
import { approvalErrorMessage } from '../../../../../../lib/premiumApprovals';
import { GAloggerException } from '../../../../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../../../../lib/access.es6';


export function* getAccessBankCustomerPremiumsRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_REQUEST);
    try {
      const response = yield call(getComplexCustomerPremiums, request.payload);
      yield put(actions.getAllAccessBankPremiumsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getAllAccessBankPremiumsFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* removeComplexPremiumRequestWatcher() {
  for (;;) {
    const request = yield take(types.REMOVE_COMPLEX_PREMIUM_REQUEST);
    try {
      const response = yield call(removeComplexPremium, request.payload);
      yield put(actions.removeComplexPremiumSuccess(response.data));
    } catch (e) {
      const errorMessage = approvalErrorMessage(e, 'An unexpected error occurred');
      yield put(actions.removeComplexPremiumFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
